import type { LocationQueryValue } from 'vue-router'

import { SurveyResponseState } from '@/composables/useSurveyResponseState'
import {
  IncentivizationCampaignIncentivizationTypeEnum,
  IncentivizationCampaignLimitTypeEnum,
  IncentivizationCampaignPersonalizationLocaleEnum,
  SurveyResponsesViewEnum,
  type RecommendationRatingKeyEnum,
  type ReviewsProductSurveyResponseDetailsQuery,
  type ReviewsProductSurveyResponsesQuery,
  type SurveyResponsesStateEnum,
} from '@/gql/reviews'

export type SurveyResponse = NonNullable<NonNullable<ReviewsProductSurveyResponsesQuery['manage']>['surveyResponses']>['results'][number]
export type SurveyResponseDetails = NonNullable<NonNullable<ReviewsProductSurveyResponseDetailsQuery['manage']>['surveyResponse']>
export type SurveyResponseReminder = SurveyResponseDetails['reminders'][number]

export type SurveyResponseReviewReply = NonNullable<SurveyResponseDetails['review']>['reviewReply']

export type SurveyRespsonseReviewPurposes = {
  title: string
}

export enum TimeFrameOptionsEnum {
  NONE = '0',
  LAST_30_DAYS = '1',
  LAST_3_MONTH = '2',
  LAST_6_MONTH = '3',
  LAST_12_MONTH = '4',
  OLDER_THAN_12_MONTH = '5',
}

export const TIMEFRAME_FILTER_GTM_VALUES: Record<TimeFrameOptionsEnum, string> = {
  [TimeFrameOptionsEnum.NONE]: 'none',
  [TimeFrameOptionsEnum.LAST_30_DAYS]: '30_days',
  [TimeFrameOptionsEnum.LAST_3_MONTH]: '3_months',
  [TimeFrameOptionsEnum.LAST_6_MONTH]: '6_months',
  [TimeFrameOptionsEnum.LAST_12_MONTH]: '12_months',
  [TimeFrameOptionsEnum.OLDER_THAN_12_MONTH]: 'older_than_12_months',
}

export interface ReviewsSortAndFilter {
  timeframe: LocationQueryValue | null
  purposes: string[] | undefined
  ratings: RecommendationRatingKeyEnum[] | undefined
  states: SurveyResponsesStateEnum[] | undefined
  interaction: LocationQueryValue | null
  view: SurveyResponsesViewEnum
}

export type ChipBadgeColor = 'default' | 'error' | 'success' | 'warning' | 'white' | 'mint' | 'purple' | 'yellow'

export type reviewsFilterMultiSelectOption = {
  text: string
  value: string
  renderType?: string
  responseState?: SurveyResponseState
  color?: ChipBadgeColor
}

export interface CampaignFormData {
  title: string | null | undefined
  locale: IncentivizationCampaignPersonalizationLocaleEnum
  validFrom: string | null | undefined
  validTo: string | null | undefined
  incentive: boolean
  incentivizationType: IncentivizationCampaignIncentivizationTypeEnum | null | undefined
  amount: number | null | undefined
  limitType: IncentivizationCampaignLimitTypeEnum | null | undefined
  incentivizationsLimit: number | null | undefined
  incentivizationsBudgetLimit: number | null | undefined
}

export interface CampaignPersonalizationFormData {
  uuid?: string
  locale: IncentivizationCampaignPersonalizationLocaleEnum
  inviteMessage: string
}

export interface CampaignEditFormData {
  title: string
  validFrom: string
  validTo?: string | null
}
